// Products & daily routine card. Mirrors
// data-component="products-daily-routine" from the approved HTML.
// Shows the reported product (Gut X here) with a confirm-daily-amount
// pill and the three fact slots (daily amount, feeding routine, supply
// estimate). Supply estimate ties to the underdosed-subscribers rule
// (project_100x_equine_underdosed_subscribers): 48.3 percent of Gut X
// sub lines run under 2 oz/day; this view surfaces the gap so a rep can
// resolve it on the call.
//
// TODO(runtime): hydrate from services/horse-timeline summarize call
// (proposed - TODO runtime; service exists, no HTTP read endpoint).
import type { ReactNode } from 'react';
import { Icon } from '../../_shared/IconSprite.js';
import type { HorseProfile, EditorMode } from '../mockData.js';

export interface ProductsDailyRoutineProps {
  horse: HorseProfile;
  onEdit: (mode: EditorMode) => void;
  /** W32: real first name on a real session. Defaults to the design-preview customer. */
  customerFirstName?: string;
}

export function ProductsDailyRoutine({ horse, onEdit, customerFirstName = 'Sarah' }: ProductsDailyRoutineProps): ReactNode {
  const product = horse.reportedProduct;
  return (
    <section className="card" data-component="products-daily-routine">
      <div className="card-head">
        <div className="row">
          <span className="head-icon">
            <Icon id="box" />
          </span>
          <h3>Products &amp; daily routine</h3>
        </div>
        <button className="text-btn" type="button" onClick={() => onEdit('routine')}>
          Edit routine
        </button>
      </div>
      <div className="routine-line">
        <span className="product-square">{product.square}</span>
        <div>
          <strong>{product.name}</strong>
          <p>{product.reportedUseLabel}</p>
        </div>
        <span className="needs-pill">Confirm daily amount</span>
      </div>
      <div className="routine-facts">
        <div>
          <span>Daily amount</span>
          <strong>{product.dailyAmount}</strong>
        </div>
        <div>
          <span>Feeding routine</span>
          <strong>{product.feedingRoutine}</strong>
        </div>
        <div>
          <span>Supply estimate</span>
          <strong>{product.daysOfSupply}</strong>
        </div>
      </div>
      <div className="plan-note">
        <Icon id="check" />
        <span>
          {customerFirstName}'s orders and subscriptions are separate from {horse.name}'s confirmed routine.
        </span>
      </div>
    </section>
  );
}
